// extracted by mini-css-extract-plugin
export var bold = "_so-0";